module.exports = __webpack_public_path__ + "media/images/Landing-banner-83cedb4e0a6550c6651f0f006c45012e.png";